import React from 'react';
import { Cta } from './Cta';
import { Reveal } from './Reveal';
export function Hero() {
  const handleStartScore = () => {
    document.getElementById('quick-check-1')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden px-6 pt-16 pb-16 md:pt-[88px] md:pb-24" data-id="element-126">
      {/* Very subtle warm lift only — intentionally NOT tan, keeps the paper canvas clean */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(90% 70% at 50% 0%, rgba(255,255,255,0.7) 0%, rgba(250,248,245,0) 60%)'
    }} aria-hidden="true" data-id="element-127" />

      <div className="relative max-w-[1180px] mx-auto grid md:grid-cols-[54fr_46fr] gap-10 md:gap-14 items-center" data-id="element-128">
        {/* LEFT COLUMN — the full hero message */}
        <Reveal data-id="element-129">
          <div className="flex flex-col items-start text-left" data-id="element-130">
            {/* Eyebrow */}
            <span className="inline-block px-4 py-1.5 bg-white/70 border border-black/[0.06] rounded-full text-xs font-semibold uppercase tracking-[0.15em] text-navy/70 mb-6 shadow-sm" data-id="element-131">
              For expert-authors whose book is already in the world
            </span>

            {/* H1 — one complete argument */}
            <h1 className="font-serif text-navy tracking-[-0.015em] text-balance leading-[1.08] text-[clamp(2.3rem,3.4vw,3.3rem)] mb-6" data-id="element-132">
              <span className="block" data-id="element-133">Your book did what a book can do.</span>
              <span className="block text-seaglass italic" data-id="element-134">
                It created authority.
              </span>
              <span className="block mt-3" data-id="element-135">But did it lead to the</span>
              <span className="block" data-id="element-136">
                <span className="text-sand-dark" data-id="element-137">opportunities</span> you
                expected?
              </span>
            </h1>

            {/* Body copy */}
            <div className="max-w-[520px] space-y-4 text-[17px] md:text-[18px] text-text-muted leading-[1.6] mb-8" data-id="element-138">
              <p data-id="element-139">
                You wrote the book. You launched it. People may have praised it,
                shared it, reviewed it, invited you on podcasts, or told you the
                ideas were exactly what they needed.
              </p>
              <p className="text-navy font-semibold" data-id="element-140">
                That matters. The book was not a failure.
              </p>
              <p data-id="element-141">
                <span className="text-navy font-semibold" data-id="element-142">
                  But most readers still disappear.
                </span>{' '}
                You do not know who cared, what landed, what they needed next,
                or whether they were a fit for the work behind the book.
              </p>
            </div>

            {/* CTA + helper */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 w-full sm:w-auto" data-id="element-143">
              <Cta variant="primary" onClick={handleStartScore} className="min-h-[56px] px-8 py-4 font-bold text-lg w-full sm:w-auto opacity-100 shadow-[0_12px_28px_-10px_rgba(212,165,116,0.7)] hover:-translate-y-0.5" data-id="element-144">
                Get Your Reader-to-Revenue Score
              </Cta>
              <p className="text-sm text-text-muted font-medium max-w-[15rem]" data-id="element-145">
                8 questions. See what happens after someone reads your book.
              </p>
            </div>
          </div>
        </Reveal>

        {/* RIGHT COLUMN — hero illustration */}
        <Reveal delay={0.2} data-id="element-146">
          <div className="flex justify-center md:justify-end" data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/sYNqZiAVEZAcKW2zQAFLK6/Untitled_design_(6).png" alt="An open book whose pages flow into a winding sea-glass path toward a warmly glowing doorway — the path from a book to real opportunities." className="w-full max-w-[520px] md:max-w-[540px] h-auto object-contain drop-shadow-[0_20px_40px_rgba(26,40,56,0.10)]" loading="eager" data-id="element-148" />
          </div>
        </Reveal>
      </div>
    </section>;
}